module.exports = __webpack_public_path__ + "files/bc53a5b3a11e8c06ba50a55f331ee2bb.svg";